<template>
    <v-card flat class="score-trans">
        <v-container fluid>
            <v-row dense v-if="Array.isArray(bookings)">
                <v-col cols="12">

                    <div class="small-font ml-4 mb-2"><b>Today's bookings ({{ this.bookings.length }})</b></div>

                    <div class="header-style score-white">
                        <tr>
                            <td style="width: 14px;" class="td-style"></td>
                            <td style="width: 62px;" class="td-style">Entry</td>
                            <td style="width: 94px;" class="td-style">Acco/Bkg</td>
                            <td style="width: 100px;" class="td-style">Stay</td>
                            <td style="width: 80px" class="td-style">Value</td>
                        </tr>
                    </div>

                    <left_panel_bookings_table :bookings="this.bookings" :height_correction="this.height_correction"/>
  
                </v-col>
            </v-row>
        </v-container>
    </v-card>

</template>

<script>

import left_panel_bookings_table from '@/components/dashboard/sections/left_panel_bookings_table.vue';

export default {    
    props: {
        bookings: Array,
        height_correction: Number,
    },    
    components: {
        left_panel_bookings_table,
    }, 
}

</script>

<style scoped>
    .score-trans {
        background: transparent !important;
    }
    .score-white {
        background: white !important;
    }    
    .header-style{
        margin-left: 2px;
        margin-bottom: 2px;
        font-weight: 600;
    }
    .td-style{
        vertical-align: top;
        border-top: 5px solid transparent;    
        font-size: 12px !important;
    }

</style>